import React, {ChangeEvent} from 'react';
import {Grid, Slider} from '@material-ui/core';

import VolumeButton from './VolumeButton/VolumeButton';

import './VolumeControls.scss';

export type VolumeChange = (event: ChangeEvent<{}>, volume: number | number[]) => void;

export interface VolumeControlsProps {
    value: number;
    muted: boolean;
    muteButtonDisabled: boolean;
    volumeChange: VolumeChange;
    onToggleMute: () => void;
}

export default function VolumeControls(props: VolumeControlsProps) {
    const {
        value,
        muted,
        muteButtonDisabled,
        volumeChange,
        onToggleMute,
    } = props;
    
    return (
        <div className="volume-root-container">
            <Grid
                container
                alignItems="center"
                wrap="nowrap"
            >
                <Slider
                    value={value}
                    onChange={volumeChange}
                    aria-label="volume-slider"
                    min={0}
                    max={1}
                    step={0.01}
                />
                
                <VolumeButton
                    muted={muted}
                    muteButtonDisabled={muteButtonDisabled}
                    onToggleMute={onToggleMute}
                />
            </Grid>
        </div>
    );
}
